var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3618 0L8.3616 13.7407L4.27722 15.888C3.78838 16.145 3.18375 15.957 2.92675 15.4682C2.82441 15.2735 2.7891 15.0505 2.82627 14.8338L3.60632 10.2858L0.301989 7.06483C-0.0934947 6.67933 -0.101587 6.04621 0.283914 5.65073C0.437423 5.49325 0.638565 5.39076 0.856202 5.35913L5.42268 4.69559L7.46487 0.557657C7.63898 0.204869 7.99333 0.00020627 8.3618 0Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54257 0.103487C8.73978 0.200817 8.89941 0.360445 8.99674 0.557657L11.0389 4.69559L15.6054 5.35913C16.1519 5.43855 16.5306 5.94599 16.4512 6.49254C16.4196 6.71018 16.3171 6.91132 16.1596 7.06483L12.8553 10.2858L13.6353 14.8338C13.7287 15.3781 13.3631 15.8951 12.8188 15.9884C12.602 16.0256 12.379 15.9903 12.1844 15.888L8.1 13.7407L8.1002 1.56075e-07C8.249 -8.31439e-05 8.4001 0.0331761 8.54257 0.103487Z",
    fill: "#FD7E14"
  }))));
};
export default SvgStarFilled;